/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import { createTemplateV2Url, uploadTemplateMediaUrl } from './urls';
import { CreateTemplateDTO, TemplateType, StrapiTemplate } from './types';

import { HsmBackendHttpClient, HsmBackendResponse } from '@/utils/http-client';

interface CreateTemplateV2Params {
  websiteId: string;
  templateBody: CreateTemplateDTO;
  file: File | null;
}

/**
 * Creates a template
 * @param params.websiteId channel that owns the template
 * @param params.templateBody props of the new template
 * @param params.file media file for IMAGE, VIDEO, or DOCUMENT
 * @returns the created template
 */
export async function createTemplateV2({
  websiteId,
  templateBody,
  file,
}: CreateTemplateV2Params): Promise<StrapiTemplate> {
  const client = HsmBackendHttpClient.instance;

  let mediaId;

  if (
    [TemplateType.IMAGE, TemplateType.VIDEO, TemplateType.DOCUMENT].includes(
      templateBody.type
    )
  ) {
    const formData = new FormData();

    formData.append('file', file!);
    formData.append('templateType', templateBody.type);

    const url1 = uploadTemplateMediaUrl(websiteId);
    const mediaFileResponse = await client.postFormData<
      HsmBackendResponse<{ mediaId: string }>
    >(url1, formData);

    mediaId = mediaFileResponse.result.mediaId;
  }

  const url2 = createTemplateV2Url(websiteId);
  const templateResponse = await client.post<
    HsmBackendResponse<{ data: StrapiTemplate }>
  >(url2, { ...templateBody, mediaId });

  return templateResponse.result.data;
}
